<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row :gutter="15">
           <el-col :span="3">
            <el-select v-model="searchParams.cpt" @change="chgSearch(3)" placeholder="选帐">
              <el-option v-for="item in  allAcout" :key="item+'y'" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-select v-model="searchParams.income" @change="chgSearch(1)" placeholder="全部">
              <el-option v-for="item in ['全部', '收入', '支出']" :key="item+'x'" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <select-option-dictionary @change="chgSearch(2)" v-model="searchParams.ctype" dkey="cw-type"
              :multiple="false" :stringMode="true" placeholder="全部分类"></select-option-dictionary>
          </el-col>

   
          <el-col :span="2">
            <el-select v-model="searchParams.state" @change="chgSearch(4)" placeholder="全状态">
              <el-option v-for="item in [   { state: -1, name: '全部' },
        { state: 0, name: '新增' },
        { state: 2, name: '已核对' },
        { state: 3, name: '需确认' },
        { state: 1, name: '已入账' },
      ]" :key="item.state+'z'" :label="item.name" :value="item.state">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" type="success" @click="search(-11)" v-if="navi && navi.prev">
              《《
            </el-button>
            <el-date-picker v-model="month" type="month" placeholder="选择月" value-format="yyyy-MM" @change="search(1)">
            </el-date-picker>
            <el-button size="mini" type="success" @click="search(11)" v-if="navi && navi.next">》》</el-button>
          </el-col>
          <el-button size="mini" @click="clearSearchVal">清空</el-button>
          <el-tag v-if="this.cptacount1 != 0 || this.cptacount2 != 0" size="mini" type="info">选中{{ index }}条合计:{{ this.cptacount1 }}{{
        this.cptacount2 }}={{ this.cptacount3 }}元</el-tag>

        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" v-has-permission-code-and="'008000010010'" size="mini" @click="toSave()">添加</el-button>
      <el-button size="mini" type="success" @click="checkDui(2)" v-if="xian">核对</el-button>
      <el-button size="mini" type="warning" @click="checkDui(3)" v-if="xian">存疑</el-button>
      <el-button size="mini" type="warning" @click="checkDui(4)" v-if="xian">撤销</el-button>
      <el-button size="mini" type="success" @click="checkDui(1)" v-if="xian">入账</el-button>
      <el-button size="mini" type="danger" @click="checkDui(5)" v-if="xian">直入</el-button>
      <el-button size="mini" type="danger" @click="batchRemove()"
        v-has-permission-code-and="'008000010015'">删除</el-button> <el-tag size="mini" type="warning" v-if="countMsg">{{
        countMsg }}</el-tag>
      <el-tag size="mini" v-if="countMsg2">{{ countMsg2 }}</el-tag>
      <el-tag size="mini" type="danger" v-if="countMsg3">{{ countMsg3 }}</el-tag>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <qlh-table class="table" :data="showListData" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        
        <qlh-table-column type="selection" width="55" fixed="left"></qlh-table-column>
        <qlh-table-column prop="cptdate" label="收支时间" width="110" sortable></qlh-table-column>
        <qlh-table-column prop="cptacount" label="金额" width="100" sortable></qlh-table-column>
        <qlh-table-column prop="cptname" label="收支名称"  width="240"></qlh-table-column>
        <qlh-table-column prop="cpttpname" label="收支账户" width="135"></qlh-table-column>
        <qlh-table-column prop="ctype" width="110" label="业务类型"> </qlh-table-column>
        <qlh-table-column prop="sptm" label="入账时间" width="170" sortable></qlh-table-column>
        <qlh-table-column prop="cptemp" width="90" label="经办人"></qlh-table-column>
      
        <qlh-table-column prop="state" width="85" label="状态">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.state == 0">新增</el-tag>
            <el-tag type="warning" size="mini" v-if="scope.row.state == 2">已对账</el-tag>
            <el-tag size="mini" type="danger" v-if="scope.row.state == 3">需确认</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.state == 1">已入账</el-tag>
          </template>
        </qlh-table-column>
        <qlh-table-column prop="remarks" label="备注"  width="210">
        </qlh-table-column>
        <qlh-table-column prop="crer" width="55" label="登记">
          <template slot-scope="scope">
            <el-tag size="mini" type="primary" v-if="scope.row.crer == '1'">R</el-tag>
            <el-tag size="mini" type="warning" v-else-if="scope.row.crer == '56493ffc15800a66a6962cc030c66eeb'">D</el-tag>
            <el-tag type="danger" size="mini" v-else>Y</el-tag>
          </template>
        </qlh-table-column>

        <qlh-table-column label="操作" fixed="right" width="280px" ignored>
          <template slot-scope="scope">
            <div class="dataTable-operator" v-if="scope.row.state != 1">
              <el-button v-if="scope.row.state == 0 || scope.row.state == 3" size="mini"
                @click="toUpdate(scope.$index, scope.row)" v-has-permission-code-and="'008000010010'">编辑</el-button>

              <el-button v-if="xian && scope.row.state > 1" size="mini"
                @click="toDuiRu(scope.$index, scope.row, 4)">对账撤销</el-button>
              <!-- && scope.row.state == 1 -->
              <!-- 对账 -->
              <el-button v-if="xian && scope.row.state == 0" size="mini"
                @click="toDuiRu(scope.$index, scope.row, 2)">核对</el-button>
              <el-button v-if="xian && scope.row.state == 0" size="mini"
                @click="toDuiRu(scope.$index, scope.row, 3)">存疑</el-button>

              <el-button v-if="xian && scope.row.state == 2" size="mini"
                @click="toDuiRu(scope.$index, scope.row, 1)">入账</el-button>

              <el-button size="mini" type="danger" v-if="scope.row.state == 0 || scope.row.state == 3"
                v-has-permission-code-and="'008000010010'" @click="remove(scope.$index, scope.row)">删除</el-button>
            </div>
          </template>
        </qlh-table-column>
      </qlh-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    
    <edit ref="edit"></edit>
  

  </div>
</template>
<script>
import edit from "./edit.vue";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import api from "@/api/cw2/cwcapitals.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import caches from "util/caches.js";
import apiUsr from "@/api/system/user/user.js";
import apiCwcnt from "@/api/cw/cwacount.js";
 

export default {
  name: "cwcapitals",
  components: {
    edit,
    qlhTable,
    qlhTableColumn,
    selectOptionDictionary
  },
  data() {
    return {
      searchParams: {
        mth: "",
      },
      isShowMoreSearch: false,
      listLoading: false,
      dialogTableVisible: false,
      listData: [],
      showListData: [],
      allAcout: ['全部', '公账', '私账','信至达存XS', '信至达妙娜私账', '信至达杨昊私账'],
      selected: [],
      states: [],
      users: [],
      cwcnts: [],
      me: {},
      flag: true,
      navi: {},
      page: new this.$constant.pageObj(),
      excel: "",
      //确认按钮控制
      xian: false,
      //选项的总金额
      cptacount1: 0,
      cptacount2: 0,
      cptacount3: 0,
      cptname: "",
      //已选项
      index: 0,
      month: "",
      // excel名称
      errorName: "",
      countMsg: false,
      countMsg2: false,
      countMsg3: false
    };
  },
  methods: {
    chgSearch(type) {

      if (type == 1) {// 按收支

        if (this.searchParams.income == '收入') {
          this.showListData = this.listData.records.filter(v => v.cptacount > 0)
        } else if (this.searchParams.income == '支出') {
          this.showListData = this.listData.records.filter(v => v.cptacount < 0)
        } else {
          this.showListData = this.listData.records
        }

      } else if (type == 2) {// 按分类

        if ( this.searchParams.ctype  ) {
          this.showListData = this.listData.records.filter(v => v.ctype == this.searchParams.ctype) 
        } else {
          this.showListData = this.listData.records
        }

      } else if (type == 3) {// 按账户过滤
            console.log(this.listData.records, this.showListData,this.searchParams)
  

        if (this.searchParams.cpt == '信至达妙娜私账' || this.searchParams.cpt == '信至达杨昊私账'|| this.searchParams.cpt == '信至达存XS') {
          this.showListData = this.listData.records.filter(v => v.cpttpname == this.searchParams.cpt)
        } else if (this.searchParams.cpt == '私账') {
          this.showListData = this.listData.records.filter(v => {
            console.log(v.cpttpname)
            return (v.cpttpname.indexOf('私账') > 0);
          })
        } else if (this.searchParams.cpt == '公账') {
          this.showListData = this.listData.records.filter(v => (v.cpttpname.indexOf('公账') > 0))
        } else {
          this.showListData = this.listData.records
        }
      }else if (type == 4) {// 全部状态
        if (this.searchParams.state >=0) {
          this.showListData = this.listData.records.filter(v => v.state == this.searchParams.state)
        } else {
          this.showListData = this.listData.records
        }
      }
       
    },
    uploadSuccess(res) {
      if (res && res.length > 5) {
        this.$utils.msg.success("上传成功!");

        let file = this.excel.substr(this.excel.lastIndexOf("/") + 1)
        this.$refs.uploaddist.open(file, "确认导入数据");

        this.dialogTableVisible = false
      } else {
        this.$alert("上传失败", "请联系管理员。", { confirmButtonText: "确定" });
      }

    }, handleClose() {

    },
    //获取数据
    list() {

      if (this.me.role2 == "admin") {
        this.xian = true;
      }

      this.listLoading = true;

      let params = this.$utils.merger(this.searchParams, this.page);

      api.list(params, (response) => {
        this.listData = response.data.pages;
        this.showListData = this.listData.records
        this.navi = response.data.navi;
        //   this.month = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
        this.month = this.navi.crnt
        this.errorName = response.data.errorName;

        if (response.data.gzcnts0) {
          let gz0 = response.data.gzcnts0 * 1
          let gz1 = response.data.gzcnts1 * 1
          let sz0 = response.data.szcnts0 * 1
          let sz1 = response.data.szcnts1 * 1
          let szR0 = response.data.szcntsR1 * 1
          let szR1 = response.data.szcntsR2 * 1
          let xs0 = response.data.cntsXS1? response.data.cntsXS1* 1:0
          let xs1 = response.data.cntsXS2 ? response.data.cntsXS2* 1:0

          this.countMsg = "上月公账 " + gz0.toFixed(0) + " 元, 私账 " + (sz0+szR0).toFixed(0) + " 元[妙 "+(sz0).toFixed(0)+",昊 "+(szR0).toFixed(0)+"元], 存新升 "+(xs0).toFixed(0)+"元";
          this.countMsg2 = "本月公账 " + gz1.toFixed(0) + " 元, 私账 " + (sz1+szR1).toFixed(0) + " 元[妙 "+(sz1).toFixed(0)+",昊 "+(szR1).toFixed(0)+"元, 存新升 "+(xs1).toFixed(0)+"元";
          this.countMsg3 = "上月结余 " + (sz0 +szR0+ gz0+xs0).toFixed(0) + "元, 本月 " + (sz1+szR1 + gz1+xs1).toFixed(0) + "元";

        } else {
          this.countMsg = false
          this.countMsg2 = false
          this.countMsg3 = false
        }

        this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      this.$refs.edit.open(
        { me: this.me, emps: this.users, cwcnts: this.cwcnts },
        "添加"
      );
    },
    //去编辑
    toUpdate(index, row) {
      this.$refs.edit.open(
        { me: this.me, emps: this.users, cwcnts: this.cwcnts, data: row },
        "编辑"
      );
    },
    //
    toDetail(index, row) {
      this.selected = [];
      this.selected.push(row.id);
      this.getName("确定对账和入账吗？", "duiRu", 3);
    },
    //对账/疑问账/入账
    toDuiRu(index, row, type) {
      this.selected = [];
      this.selected.push(row.id);
      if (type == 2) {
        this.getName("确定对账吗？", "dui", 2);
      } else if (type == 3) {
        this.getName("添加到疑问账吗？", "dui", 3);
      } else if (type == 1) {
        this.getName("确定入账吗？", "ru", 1);
      } else if (type == 4) {
        this.getName("撤销对账吗？", "che", 0);
      }
    },
    getName(title, type, state) {
      let name = this.$caches.roleCode.get()[0];
      let parameter = {
        name: name,
        ids: this.selected,
        type: type,
        state: state,
      };
      let parameters = this.$utils.merger(parameter);
      this.$utils.confirm.warning("提示", title, () => {
        api.updateDan(
          parameters,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },

    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }

      this.states.forEach((v) => {
        if (!(v == 0 || v == 3)) {
          this.flag = false;
          return;
        }
      });
      if (this.flag) {
        let parameter = {
          ids: this.selected,
        };
        this.$utils.confirm.warning("提示", "确定删除吗？", () => {
          api.remove(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
            }
          );
        });
      } else {
        this.$utils.msg.warning("选择的行存在不满足操作条件");
      }
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },

    //改变选择项
    selectionChange(val) {
      //清空
      this.index = 0;
      this.selected = [];
      this.states = [];
      this.cptacount1 = 0;
      this.cptacount2 = 0;
      this.cptacount3 = 0;
      for (let item of val) {
        this.selected.push(item.id);
        this.states.push(item.state);
        if (item.cptacount > 0) {
          this.cptacount1 = this.add(this.cptacount1, item.cptacount);
        } else {
          this.cptacount2 = this.add(this.cptacount2, item.cptacount);
        }

        this.index++;
      }

      this.cptacount3 = (this.cptacount1 + this.cptacount2).toFixed(0)
      this.cptacount1 = this.cptacount1.toFixed(0)
      this.cptacount2 = this.cptacount2.toFixed(0)
      
    },
    //计算精度
    add(num1, num2) {
      const num1Digits = (num1.toString().split(".")[1] || "").length;
      const num2Digits = (num2.toString().split(".")[1] || "").length;
      const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
      return (num1 * baseNum + num2 * baseNum) / baseNum;
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索
    search(type) {
      this.page.current = 1;
      this.cptname = ""
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.mth = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.mth = this.navi.next;
        } else if (type == 1) {
          //下1月
          this.searchParams.mth = this.month;
        }
      }
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.cptname = ""
      this.searchParams = {};
      this.search(1)
    },

    toUpload() {
      //准备上传
      this.dialogTableVisible = true;
    },

    cfmUpload() {
      //确认上传
      this.dialogTableVisible = false;
    },
    upldChange(res) {
      if (res && res.length > 10) {
        //
        this.$utils.msg.success("上传成功");

        this.dialogTableVisible = false;

        let fn = res.substring(res.lastIndexOf("/") + 1);
        //调用解析   upload
        api.uploadDatas(
          { fname: fn },
          (res) => {
            this.$alert(
              "<strong>失败 " +
              res.data.errorCount +
              "条，成功： <i>" +
              res.data.successCount +
              "条</i> </strong><br>" +
              "",
              {
                dangerouslyUseHTMLString: true,
              }
            );

            this.list();
          },
          (response) => {
            this.$utils.msg.warning("解析失败");
          }
        );
      } else {
        this.$utils.msg.fail("上传失败");
      }
    },
    //对账
    checkDui(type) {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }

      this.flag = true;

      if (type == 1) {//批量入账
        this.states.forEach((v) => {
          if (v != 2) {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          this.getCheck("确定批量入账吗?", "ru", 1);
        } else {
          this.$utils.msg.warning("选择的行存在不满足操作条件");
        }
      } else if (type == 2) {//批量对账
        this.states.forEach((v) => {
          if (v != 0) {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          this.getCheck("确定批量对账吗?", "dui", 2);
        } else {
          this.$utils.msg.warning("选择的行存在不满足操作条件");
        }
      } else if (type == 3) {//存疑
        this.states.forEach((v) => {
          if (v != 0) {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          this.getCheck("确定批量存疑吗?", "dui", 3);
        } else {
          this.$utils.msg.warning("选择的行存在不满足操作条件");
        }
      } else if (type == 4) {//批量撤销
        this.states.forEach((v) => {
          if (!(v == 2 || v == 3)) {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          this.getCheck("确定批量撤销对账吗?", "che", 0);
        } else {
          this.$utils.msg.warning("选择的行存在不满足操作条件");
        }
      } else if (type == 5) {//直接入账
        this.states.forEach((v) => {
          if (!(v == 0 || v == 2)) {
            this.flag = false;
            return;
          }
        });
        if (this.flag) {
          this.getCheck("确定批量直接入账吗?", "duiRu", 1);
        } else {
          this.$utils.msg.warning("选择的行存在不满足操作条件");
        }
      }
    },
    getCheck(title, type, state) {
      let name = this.$caches.roleCode.get()[0];
      let parameter = {
        name: name,
        ids: this.selected,
        type: type,
        state: state,
      };
      let parameters = this.$utils.merger(parameter);
      this.$utils.confirm.warning("提示", title, () => {
        api.updateDan(
          parameters,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //撤销对账
    updateCwcapitals(index, row) {
      let parameter = {
        id: row.id,
      };
      let parameters = this.$utils.merger(parameter);
      this.$utils.confirm.warning("提示", "确定撤销对账吗?", () => {
        api.updateCwcapitals(
          parameters,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    //异常流水帐下载
    errorCwcapitals() {
      let parameter = {
        file: this.errorName,
      };
      let tokenVal = caches.token.get();
      api.downloadCwcapitals(null, parameter, { token: tokenVal });
    },
  },
  mounted() {
    apiUsr.listAllEmps({isXzd:1},(res) => {
      this.users = res.data;
      this.me = this.$caches.user.get();

      let date = new Date();
      this.searchParams.mth = date.format("yyyy-MM");
      this.list();

      apiCwcnt.list({ inUse: 1,isXzd: 1 }, (res2) => {
        this.cwcnts = res2.data;
      });
    });

    this.page.size = 500
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.operator {
  margin-top: 10px;
}

.errorClass {
  margin-top: 4px;
}
</style>
